module.exports = __webpack_public_path__ + "static/media/Logo_NIEC_large.4baea657.png";